import {useLocation} from './useLocation';
import {useHistory} from './useHistory';
import {useInitialLocation} from './context';
import {useCallback} from 'react';
import {useCompleteLocation} from './react-router';

export const useIsInitialLocation = () => {
  const location = useLocation();
  const initialLocation = useInitialLocation();

  return (
    location.pathname === initialLocation.pathname &&
    Boolean(location.search) === Boolean(initialLocation.search)
  );
};

export const useIsInitialLocationCallback = () => {
  const history = useHistory();
  const initialLocation = useInitialLocation();

  return useCallback(() => {
    return (
      history.location.pathname === initialLocation.pathname &&
      Boolean(history.location.search) === Boolean(initialLocation.search)
    );
  }, [history, initialLocation]);
};

export const useIsDirectEntryCallback = () => {
  const history = useHistory();
  const location = useCompleteLocation();
  const isInitialLocationCallback = useIsInitialLocationCallback();

  return useCallback(() => {
    return (
      isInitialLocationCallback() &&
      Boolean(history.location.key) === Boolean(location.key)
    );
  }, [history.location.key, isInitialLocationCallback, location.key]);
};
